import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { featuredMovies } from '@/mocks/movies';

const bannerImages: Record<string, string> = {
  'movie-interstellar': 'https://readdy.ai/api/search-image?query=cinematic%20movie%20scene%20Interstellar%20dramatic%20lighting%20dark%20atmosphere%20film%20poster%20style%20high%20quality%20cinematic%20photography%20warm%20golden%20tones%20on%20dark%20background%20professional%20movie%20banner%20with%20copy%20space&width=1920&height=800&seq=hero-banner-interstellar&orientation=landscape',
  'movie-wandering-earth': 'https://readdy.ai/api/search-image?query=cinematic%20movie%20scene%20The%20Wandering%20Earth%202%20dramatic%20lighting%20dark%20atmosphere%20sci%20fi%20film%20poster%20style%20high%20quality%20cinematic%20photography%20warm%20golden%20tones%20on%20dark%20background%20professional%20movie%20banner&width=1920&height=800&seq=hero-banner-wandering-earth&orientation=landscape',
  'movie-hi-mom': 'https://readdy.ai/api/search-image?query=cinematic%20movie%20scene%20Hi%20Mom%20Chinese%20comedy%20drama%20warm%20lighting%20nostalgic%20atmosphere%20film%20poster%20style%20high%20quality%20cinematic%20photography%20warm%20golden%20tones%20professional%20movie%20banner&width=1920&height=800&seq=hero-banner-hi-mom&orientation=landscape',
  'movie-changjin': 'https://readdy.ai/api/search-image?query=cinematic%20movie%20scene%20The%20Battle%20at%20Lake%20Changjin%20war%20drama%20dramatic%20lighting%20dark%20atmosphere%20film%20poster%20style%20high%20quality%20cinematic%20photography%20professional%20movie%20banner&width=1920&height=800&seq=hero-banner-changjin&orientation=landscape',
  'tv-zhenhuan': 'https://readdy.ai/api/search-image?query=cinematic%20Chinese%20period%20drama%20Empresses%20in%20the%20Palace%20Zhen%20Huan%20elegant%20lighting%20imperial%20palace%20atmosphere%20film%20poster%20style%20high%20quality%20cinematic%20photography%20professional%20drama%20banner&width=1920&height=800&seq=hero-banner-zhenhuan&orientation=landscape',
};

export default function HeroBanner() {
  const [current, setCurrent] = useState(0);

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrent((prev) => (prev + 1) % featuredMovies.length);
    }, 5000);
    return () => clearInterval(timer);
  }, []);

  const movie = featuredMovies[current];
  const bannerSrc = bannerImages[movie.imageSeq] || bannerImages['movie-interstellar'];

  return (
    <section className="relative w-full h-[420px] md:h-[600px] overflow-hidden">
      <img
        src={bannerSrc}
        alt={movie.title}
        className="absolute inset-0 w-full h-full object-cover object-top transition-opacity duration-1000"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/60 via-black/40 to-background-950"></div>
      <div className="absolute inset-0 flex items-end pb-12 md:pb-16">
        <div className="w-full px-4 md:px-6">
          <div className="max-w-2xl">
            <div className="flex items-center gap-3 mb-3 flex-wrap">
              <span className="px-3 py-1 bg-primary-500/90 text-background-950 text-xs font-semibold rounded-full">
                {movie.categoryName}
              </span>
              <span className="text-foreground-300 text-sm">{movie.year}</span>
              <span className="flex items-center gap-1 text-primary-400 text-sm">
                <i className="ri-star-fill"></i>
                {movie.rating}
              </span>
            </div>
            <h1 className="text-2xl md:text-4xl font-bold text-white mb-3 font-heading">{movie.title}</h1>
            <p className="text-foreground-300 text-sm md:text-base leading-relaxed mb-5 hidden sm:block line-clamp-2">
              {movie.description}
            </p>
            <div className="flex items-center gap-3">
              <Link
                to={`/article/${movie.id}`}
                className="inline-flex items-center gap-2 px-6 py-2.5 bg-primary-500 hover:bg-primary-600 text-background-950 font-semibold text-sm rounded-full transition-all duration-200 whitespace-nowrap"
              >
                <i className="ri-play-fill text-lg"></i>
                立即观看
              </Link>
              <Link
                to={`/article/${movie.id}`}
                className="inline-flex items-center gap-2 px-6 py-2.5 border border-foreground-300/40 text-white hover:border-primary-400 hover:text-primary-400 text-sm rounded-full transition-all duration-200 whitespace-nowrap"
              >
                <i className="ri-information-line"></i>
                详细介绍
              </Link>
            </div>
          </div>
        </div>
      </div>

      <div className="absolute bottom-6 right-6 flex items-center gap-2">
        {featuredMovies.map((_, idx) => (
          <button
            key={idx}
            onClick={() => setCurrent(idx)}
            className={`w-2 h-2 rounded-full transition-all duration-300 ${
              idx === current
                ? 'bg-primary-500 w-6'
                : 'bg-foreground-400/50 hover:bg-foreground-300'
            }`}
          />
        ))}
      </div>
    </section>
  );
}